
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/masjid",
      function () {
        return require("private-next-pages/masjid/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/masjid"])
      });
    }
  